import generateReportUrlTail from './generateReportUrlTail';

export default (collectionType, params) => {
  if (params.parentId === undefined) {
    return `/reports/${collectionType}`;
  }

  return `/reports/${collectionType}/${params.parentId}${generateReportUrlTail(params)}`;
}
